// extracted by mini-css-extract-plugin
export default {"container":"Memo_container__msnpd","content":"Memo_content__zdI0N","title":"Memo_title__ZNsZ7"};